import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { AuthenticationService } from "src/app/core/services/authentication.service";
import { SettingService } from "src/app/core/services/setting.service";
import { MatDialogRef } from "@angular/material/dialog";
import { environment } from "src/environments/environment";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { CategorymasterService } from "src/app/core/services/categorymaster.service";
import { data } from "jquery";
import { Subject } from "rxjs";
import * as Dropzone from "dropzone";
import { BusinessAccount } from "src/app/shared/models/business-account.model";
// import { BusinessAccountCreateComponent } from "src/app/modules/admin/business_accounts/all-business-account/pages/business-account-create/business-account-create.component";
import { AccountCreated } from "../account_created/account_created.component";
import { BusinessAccountService } from "src/app/core/services/business-account.service";
import { CartService } from "src/app/core/services/productShared.service";
// import { debug } from 'console';
// import { error } from 'console';

@Component({
    selector: "app-dashboard-stepper",
    templateUrl: "./dashboard-stepper.component.html",
    styleUrls: ["./dashboard-stepper.component.scss"],
})
export class DashboardStepperComponent implements OnInit {
    private apiUrl = environment.apiUrl;
    @ViewChild("profileFileInput", { static: false })
    profileFileInput!: ElementRef<HTMLInputElement>;
    @ViewChild("profileDropzone", { static: false })
    profileDropzone!: ElementRef<HTMLDivElement>;
    @ViewChild("logoFileInput", { static: false })
    logoFileInput!: ElementRef<HTMLInputElement>;
    @ViewChild("logoDropzone", { static: false })
    logoDropzone!: ElementRef<HTMLDivElement>;

    // stepperForm: FormGroup;
    settings: any;
    public onClose: Subject<boolean>;

    isSettingsLoad: boolean;
    backgroundImage: string;
    complianceForm: FormGroup;
    step: number = 1;
    totalSteps = 5;
    public ComplienceForm: FormGroup;
    industryType: any;
    businessType: any;
    complianceField: any;
    complianceStatus: { [key: string]: boolean | null } = {};
    loginUser: any;
    userId: number;
    countries: any;
    states: any;
    city: any;
    myDropzone: any;
    profilePhotoFile: File | null = null;
    profilePhotoPreview: string | ArrayBuffer | null = null;
    logoPhoto: string | null = null;
    logoPhotoPreview: string | ArrayBuffer | null = null;
    logoPhotoFile: File | null = null;
    businessIdToSend: any;
    emailId: any;
    firstName: any;
    lastName: any;

    constructor(
        public translate: TranslateService,
        private router: Router,
        private formBuilder: FormBuilder,
        private toastr: ToastrService,
        private authenticationService: AuthenticationService,
        private settingService: SettingService,
        private categoryService: CategorymasterService,
        public bsModalRef: BsModalRef,
        private http: HttpClient,
        private modalService: BsModalService,
        private bussinessAccountService: BusinessAccountService,
        private productSharedService: CartService
    ) {
        this.complianceForm = this.formBuilder.group({
            //step1
            // id:loginUserRaw.id,
            verifiedBy: ["Admin"],
            verifiedRemarks: ["Verified"],
            // Step 2
            businessName: ["", Validators.required],
            industryTypeId: [null, Validators.required],
            businessTypeId: [null, Validators.required],
            tagLine: ["", Validators.required],
            slugUrl: [""],

            // step 3
            addressLine1: ["", Validators.required],
            addressLine2: [""],
            areaName: [""],
            district: ["", Validators.required],
            country: [null, Validators.required],
            state: [null, Validators.required],
            city: [null, Validators.required],
            pincode: [
                "",
                [
                    Validators.required,
                    Validators.pattern(/^[0-9]{6}$/), // exact 6 digits
                    Validators.minLength(6),
                    Validators.maxLength(6),
                ],
            ],
            addressType: [23],
            longitude: ["", Validators.required],
            latitude: ["", Validators.required],

            firstName: [this.firstName, Validators.required],
            lastName: [this.lastName, Validators.required],
            phoneNumber: [
                "",
                [Validators.required, Validators.pattern(/^\d{10}$/)],
            ],
            email: [this.emailId, [Validators.required, Validators.email]],
            profilePhoto: [null, [Validators.required, this.validateImage]],
        });
    }

    ngOnInit() {
        const business_account_id = localStorage.getItem("business_account_id");

        if (business_account_id) {
            this.loadBusinessAccount();
        }
        this.getcomplianceFiled();
        this.loadDropdownData();
        this.getcountry();
        this.onClose = new Subject();

        const loginUserRaw = localStorage.getItem("loginUser");
        if (loginUserRaw) {
            this.loginUser = JSON.parse(loginUserRaw);
            this.userId = this.loginUser.id;
            this.emailId = this.loginUser.email;
            this.firstName = this.loginUser.firstname;
            this.lastName = this.loginUser.lastname;
        }

        console.log("userid", this.userId);
        this.loadBusinessAccount();
    }

    getcomplianceFiled() {
        this.categoryService.getByTypeId(8).subscribe((res3: any) => {
            this.complianceField = res3.data;
            console.log("complaince formmmmmmmmmmmmmmmm", this.complianceField);

            this.complianceField.forEach((field) => {
                let validators = [Validators.required];

                // add pattern validators based on field name
                const fieldName = field.name.toLowerCase();
                if (
                    fieldName === "gstnumber" ||
                    fieldName === "gst_no" ||
                    fieldName === "gst"
                ) {
                    validators.push(
                        Validators.pattern(
                            /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
                        )
                    );
                    validators.push(Validators.minLength(15));
                    validators.push(Validators.maxLength(15));
                } else if (
                    fieldName === "pannumber" ||
                    fieldName === "pan_card" ||
                    fieldName === "pan"
                ) {
                    validators.push(
                        Validators.pattern(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/)
                    );
                    validators.push(Validators.minLength(10));
                    validators.push(Validators.maxLength(10));
                } else if (
                    fieldName === "aadharnumber" ||
                    fieldName === "aadhar_card" ||
                    fieldName === "aadhaar"
                ) {
                    validators.push(Validators.pattern(/^\d{12}$/));
                    validators.push(Validators.minLength(12));
                    validators.push(Validators.maxLength(12));
                }

                this.complianceForm.addControl(
                    field.name,
                    this.formBuilder.control("", validators)
                );
            });
        });
    }
    validateImage(control: any) {
        const file = control.value;
        if (!file) return null;

        // File type validation
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (file && !allowedTypes.includes(file.type)) {
            return { invalidType: true };
        }

        // File size validation (max 2MB)
        if (file.size > 2 * 1024 * 1024) {
            return { fileSizeExceeded: true };
        }

        return null;
    }

    getcountry() {
        this.categoryService.getByTypeId(1).subscribe((res4: any) => {
            this.countries = res4.data;
            console.log(this.countries);
        });
    }

    onCountryChange(event: any) {
        const countryId = event.target.value;

        // Reset state and city form controls safely
        const stateControl = this.complianceForm.get("state");
        if (stateControl) {
            stateControl.reset("");
        }

        const cityControl = this.complianceForm.get("city");
        if (cityControl) {
            cityControl.reset("");
        }

        // Clear old data
        this.states = [];
        this.city = [];

        // Load states if a valid country is selected
        if (countryId) {
            this.categoryService
                .getByTypeIdParentId("state", countryId)
                .subscribe((res: any) => {
                    this.states = res.data || [];
                });
        }
    }

    onStateChange(event: any) {
        const stateId = event.target.value;

        // Reset city form control safely
        const cityControl = this.complianceForm.get("city");
        if (cityControl) {
            cityControl.reset("");
        }

        // Clear old city data
        this.city = [];

        // Load cities if a valid state is selected
        if (stateId) {
            this.categoryService
                .getByTypeIdParentId("city", stateId)
                .subscribe((res: any) => {
                    this.city = res.data || [];
                });
        }
    }

    loadDropdownData() {
        this.categoryService.getById(4).subscribe((res1: any) => {
            this.businessType = res1.data;
        });

        this.categoryService.getById(5).subscribe((res2: any) => {
            this.industryType = res2.data;
        });
    }

    nextStep() {
        // mark all fields in current step as touched
        this.markStepFieldsAsTouched(this.step); // mark fields as touched

        // now check if step is valid
        if (!this.isStepValid()) {
            this.toastr.error("Please fill all required fields"); //
            return; // stop moving to next step
        }

        // save step data if needed
        this.saveStepData(this.step, () => {
            this.step++;
        });
    }
    // toUpperCase(fieldName: string, event: any) {
    //     const value = event.target.value.toUpperCase();

    //     this.complianceForm.get(fieldName)?.setValue(value, {
    //         emitEvent: false,
    //     });
    // }


    markStepFieldsAsTouched(step: number) {
        let fields: string[] = [];

        switch (step) {
            case 1:
                fields = this.complianceField
                    ? this.complianceField.map((f) => f.name)
                    : [];
                break;
            case 2:
                fields = [
                    "businessName",
                    "industryTypeId",
                    "businessTypeId",
                    "tagLine",
                ];
                break;
            case 3:
                fields = [
                    "addressLine1",
                    "addressLine2",
                    "areaName",
                    "district",
                    "country",
                    "state",
                    "city",
                    "pincode",
                    "longitude",
                    "latitude",
                ];
                break;
            case 4:
                fields = ["firstName", "lastName", "phoneNumber", "email"];
                break;
            case 5:
                fields = []; // step 5 has no required fields
                break;
        }

        fields.forEach((f) => {
            const control = this.complianceForm.get(f);
            if (control) control.markAsTouched();
        });
    }

    prevStep() {
        if (this.step > 1) {
            this.step--;
        }
    }

    saveStepData(currentStep: number, callback?: () => void) {
        const storedUser = localStorage.getItem("loginUser");
        const userData = storedUser ? JSON.parse(storedUser) : null;
        const storedBusinessId = localStorage.getItem("business_account_id");
        console.log("Stored Business ID:", storedBusinessId);

        if (
            !storedBusinessId ||
            storedBusinessId === "null" ||
            storedBusinessId === "undefined"
        ) {
            this.businessIdToSend = 0;
        } else {
            this.businessIdToSend = Number(storedBusinessId);
        }

        const formData = this.complianceForm.value;

        // Prepare compliance data (only for step 1)
        const complianceArray = this.complianceField.map((field) => ({
            complianceValue: formData[field.name],
            verifiedBy: formData.verifiedBy || "Admin",
            verifiedRemarks: formData.verifiedRemarks || "Verified",
            complianceType: field.id,
            complianceTypeStr: field.name,
        }));

        const payload = {
            user: {
                // contactNumber: formData.phoneNumber,
                email: formData.email,
                id: this.userId,
                userType: "business-account",
                userBusinessRoleId: 80,
                fullName: formData.firstName,
            },
            compliance: currentStep === 1 ? complianceArray : [],
            business:
                currentStep >= 2
                    ? {
                        id: this.businessIdToSend,
                        businessName: formData.businessName,
                        industryTypeId: formData.industryTypeId,
                        businessTypeId: formData.businessTypeId,
                        tagLine: formData.tagLine || "",
                        slugUrl: formData.slugUrl || "",
                    }
                    : { id: this.businessIdToSend, businessName: "" },
            address:
                currentStep >= 3
                    ? {
                        addressLine1: formData.addressLine1,
                        addressLine2: formData.addressLine2,
                        areaName: formData.areaName,
                        district: formData.city,
                        country: formData.country,
                        state: formData.state,
                        city: formData.city,
                        pincode: formData.pincode,
                        addressType: 23,
                        longitude: formData.longitude,
                        latitude: formData.latitude,
                    }
                    : {},
            contact:
                currentStep >= 4
                    ? {
                        contactType: 24,
                    }
                    : {
                        contactType: 24,
                    },
        };

        const formData1 = new FormData();
        formData1.append(
            "data",
            new Blob([JSON.stringify(payload)], { type: "application/json" })
        );

        if (currentStep === 5) {
            // only attach files in last step
            if (this.profilePhotoFile) {
                formData1.append(
                    "profileImage",
                    this.profilePhotoFile,
                    this.profilePhotoFile.name
                );
            }
            if (this.logoPhotoFile) {
                formData1.append(
                    "logo",
                    this.logoPhotoFile,
                    this.logoPhotoFile.name
                );
            }
        }

        this.authenticationService.stepperRegister(formData1).subscribe({
            next: (res: any) => {
                this.toastr.success("Step data saved successfully");

                if (res) {
                    localStorage.setItem("business_account_id", res.businessId);
                    localStorage.setItem(
                        "business_account_name",
                        res.businessName
                    );
                    // localStorage.setItem('profile_status_percentage', res.profile_status_percentage)
                    this.productSharedService.setProgress(
                        res.profile_status_percentage
                    );
                    this.loadBusinessAccount();
                    // localStorage.setItem('profile_status_percentage', res.profile_status_percentage);
                }

                if (callback) callback();
            },
            error: (err) => {
                console.error("Error saving step data:", err);
                this.toastr.error("Something went wrong while saving step");
            },
        });
    }

    getMasterTypeData() {
        this.categoryService.getById;
    }

    submitForm() {
        const storedUser = localStorage.getItem("loginUser");
        const userData = storedUser ? JSON.parse(storedUser) : null;
        const business_account_id = localStorage.getItem("business_account_id");

        const formData = this.complianceForm.value;
        const complianceArray = this.complianceField.map((field) => ({
            complianceValue: formData[field.name],
            verifiedBy: formData.verifiedBy || "Admin",
            verifiedRemarks: formData.verifiedRemarks || "Verified",
            complianceType: field.id,
            complianceTypeStr: field.name,
        }));

        const payload = {
            user: {
                id: this.userId,
                userType: "business_account",
                userBusinessRoleId: 21,
            },
            compliance: complianceArray,

            business: {
                id: business_account_id || 0,
                businessName: formData.businessName,
                industryTypeId: formData.industryTypeId,
                businessTypeId: formData.businessTypeId,
                tagLine: "", // add field if needed in form
                slugUrl: formData.slugUrl,
            },
            contact: {
                contactType: 24, // or get from form if added
            },
            address: {
                addressLine1: formData.addressLine1,
                addressLine2: formData.addressLine2,
                areaName: formData.areaName,
                district: formData.city,
                country: formData.country,
                city: formData.city,
                state: formData.state,
                pincode: formData.pincode,
                addressType: formData.addressType,
                longitude: formData.longitude,
                latitude: formData.latitude,
            },
            // attachmentFiles : []
        };

        const formData1 = new FormData();
        formData1.append(
            "data",
            new Blob([JSON.stringify(payload)], { type: "application/json" })
        );

        // attach files if they exist
        if (this.profilePhotoFile) {
            formData1.append(
                "profileImage",
                this.profilePhotoFile,
                this.profilePhotoFile.name
            );
        }
        if (this.logoPhotoFile) {
            formData1.append(
                "logo",
                this.logoPhotoFile,
                this.logoPhotoFile.name
            );
        }

        this.authenticationService.stepperRegister(formData1).subscribe({
            next: (res: any) => {
                this.toastr.success(
                    this.translate.instant("Your Business Account Has Created")
                );

                if (res) {
                    this.productSharedService.setProgress(
                        res.profile_status_percentage
                    );
                }
                // ✅ Close modal
                this.bsModalRef.hide();

                this.modalService.show(AccountCreated, {
                    animated: true,
                    keyboard: true,
                    backdrop: "static",
                    class: "modal-dialog-centered modal-lg order-success-dialog",
                });
            },
            error: (error) => {
                console.log("Error", error);
            },
        });
        this.bsModalRef.hide();
    }
    allowOnlyDigits(event: any) {
        event.target.value = event.target.value.replace(/[^0-9]/g, "");
    }

    onCancel() {
        this.onClose.next(false);
        this.bsModalRef.hide();
    }

    selectOption(controlName: string, value: any): void {
        const control = this.complianceForm.get(controlName);
        if (control) {
            control.setValue(value);
            control.markAsTouched();
        }
    }

    checkCompliance(fieldName: string) {
        const complianceValue = this.complianceForm.get(fieldName).value; // adjust form name if needed
        if (complianceValue) {
            this.authenticationService
                .verifyComplaince(fieldName, { complianceValue })
                .subscribe(
                    (res: any) => {
                        this.complianceStatus[fieldName] = res === true;
                    },
                    (err) => {
                        this.complianceStatus[fieldName] = false;
                        console.error("Verification error:", err);
                    }
                );
        }
    }

    private complianceTimeout: any;

    onComplianceInput(fieldName: string) {
        clearTimeout(this.complianceTimeout);

        this.complianceTimeout = setTimeout(() => {
            this.checkCompliance(fieldName);
        }, 2000); // waits 600ms after typing stops
    }

    loadBusinessAccount() {
        const business_account_id = localStorage.getItem("business_account_id");
        if (!business_account_id) return;

        this.categoryService.getStepperData(business_account_id).subscribe(
            (res: any) => {
                console.log("Stepper Data:", res);

                const business = res && res.business ? res.business : {};
                const address = res && res.address ? res.address : {};
                const user = res && res.user ? res.user : {};
                const compliance = res && res.compliance ? res.compliance : [];

                this.complianceForm.patchValue({
                    // --- Business section ---
                    businessName: business.businessName || "",
                    industryTypeId: business.industryTypeId || null,
                    businessTypeId: business.businessTypeId || null,
                    tagLine: business.tagLine || "",
                    slugUrl: business.slugUrl || "",

                    // --- Address section ---
                    addressLine1: address.addressLine1 || "",
                    addressLine2: address.addressLine2 || "",
                    areaName: address.areaName || "",
                    district: address.district || "",
                    country: address.country || "",
                    state: address.state || "",
                    city: address.city || "",
                    pincode: address.pincode || "",
                    addressType: address.addressType || "",
                    longitude: address.longitude || "",
                    latitude: address.latitude || "",

                    // --- User section ---
                    // email: user.email || "",
                    // firstName: user.fullName ? user.fullName.split(" ")[0] : "",
                    // lastName:
                    //     user.fullName && user.fullName.split(" ")[1]
                    //         ? user.fullName.split(" ")[1]
                    //         : "",
                    // phoneNumber: user.contactNumber || "",
                });

                if (address.country) {
                    this.complianceForm
                        .get("country")
                        .setValue(address.country);

                    // Load states after country
                    this.categoryService
                        .getByTypeIdParentId("state", address.country)
                        .subscribe((stateRes: any) => {
                            this.states = stateRes.data || [];

                            if (address.state) {
                                this.complianceForm
                                    .get("state")
                                    .setValue(address.state);

                                // Load cities after state
                                this.categoryService
                                    .getByTypeIdParentId("city", address.state)
                                    .subscribe((cityRes: any) => {
                                        this.city = cityRes.data || [];
                                        if (address.city) {
                                            this.complianceForm
                                                .get("city")
                                                .setValue(address.city);
                                        }
                                    });
                            }
                        });
                }

                // --- Compliance fields ---
                if (Array.isArray(compliance) && compliance.length) {
                    compliance.forEach(function (comp) {
                        const field = this.complianceField.find(function (f) {
                            return f.id === comp.complianceType;
                        });
                        if (field && this.complianceForm.get(field.name)) {
                            this.complianceForm
                                .get(field.name)
                                .patchValue(comp.complianceValue || "");
                        }
                    }, this);
                }
            },
            (err) => {
                console.error("Error loading business account data:", err);
            }
        );
    }

    onProfilePhotoSelected(event: any): void {
        const file: File | undefined =
            event.target.files && event.target.files[0];

        if (!file) return;

        // Save file
        this.profilePhotoFile = file;

        // Set value to FormControl for validation
        this.complianceForm.get("profilePhoto").setValue(file);
        this.complianceForm.get("profilePhoto").markAsTouched();

        // Show preview
        const reader = new FileReader();
        reader.onload = (e: any) => {
            this.profilePhotoPreview = e.target.result;
        };
        reader.readAsDataURL(file);
    }

    onProfileDropzoneClick(): void {
        if (this.profileFileInput && this.profileFileInput.nativeElement) {
            this.profileFileInput.nativeElement.click();
        }
    }

    removeProfilePhoto(evt: Event): void {
        evt.stopPropagation();
        this.profilePhotoFile = null;
        this.profilePhotoPreview = null;
        if (this.profileFileInput && this.profileFileInput.nativeElement) {
            this.profileFileInput.nativeElement.value = "";
        }
    }

    triggerLogoFileInput(): void {
        this.logoFileInput.nativeElement.click();
    }

    onLogoPhotoSelect(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files[0]) {
            this.logoPhotoFile = input.files[0];
            const reader = new FileReader();
            reader.onload = (e: any) => {
                this.logoPhoto = e.target.result;
            };
            reader.readAsDataURL(input.files[0]);
        }
    }

    removeLogoPhoto(): void {
        this.logoPhoto = null;
        this.logoPhotoFile = null;
        this.logoFileInput.nativeElement.value = "";
    }

    isStepValid(): boolean {
        switch (this.step) {
            case 1:
                if (
                    !this.complianceField ||
                    this.complianceField.length === 0
                ) {
                    return false;
                }
                for (let i = 0; i < this.complianceField.length; i++) {
                    const field = this.complianceField[i];
                    const control = this.complianceForm.get(field.name);
                    if (!control || !control.value || !control.valid) {
                        return false;
                    }
                }
                return true;

            case 2:
                return (
                    this.complianceForm.get("businessName") &&
                    this.complianceForm.get("businessName").valid &&
                    this.complianceForm.get("industryTypeId") &&
                    this.complianceForm.get("industryTypeId").valid &&
                    this.complianceForm.get("businessTypeId") &&
                    this.complianceForm.get("businessTypeId").valid &&
                    this.complianceForm.get("tagLine") &&
                    this.complianceForm.get("tagLine").valid
                );

            case 3:
                return (
                    this.complianceForm.get("addressLine1") &&
                    this.complianceForm.get("addressLine1").valid &&
                    this.complianceForm.get("country") &&
                    this.complianceForm.get("country").valid &&
                    this.complianceForm.get("state") &&
                    this.complianceForm.get("state").valid &&
                    this.complianceForm.get("city") &&
                    this.complianceForm.get("city").valid &&
                    this.complianceForm.get("pincode") &&
                    this.complianceForm.get("pincode").valid
                );

            // case 4:
            //     return (
            //         this.complianceForm.get("firstName") &&
            //         this.complianceForm.get("firstName").value &&
            //         this.complianceForm.get("lastName") &&
            //         this.complianceForm.get("lastName").value &&
            //         this.complianceForm.get("phoneNumber") &&
            //         this.complianceForm.get("phoneNumber").value &&
            //         this.complianceForm.get("email") &&
            //         this.complianceForm.get("email").value
            //     );

            case 4:
                return true;

            default:
                return false;
        }
    }

    private VerfiyBusinessNameTimeOut: any;

    onBusinessNameInput(fieldName: string) {
        clearTimeout(this.complianceTimeout);

        this.complianceTimeout = setTimeout(() => {
            this.verifyBusinessAccountName();
        }, 2000); // waits 600ms after typing stops
    }

    verifyBusinessAccountName() {
        const control = this.complianceForm.get("businessName");
        const name = String(control.value.trim());
        // const payload = {
        //     businessName: name,
        // };

        if (!name) return; // avoid unnecessary API calls

        this.bussinessAccountService.verifyBusinessName(name).subscribe({
            next: (res: any) => {
                if (res === true) {
                    // ✅ set custom validation error
                    control.setErrors({ nameTaken: true });
                } else {
                    // ✅ clear any previous "nameTaken" error but keep other ones (like required)
                    if (control.hasError("nameTaken")) {
                        control.setErrors(null);
                    }
                }
            },
            error: (err) => {
                console.error("Error verifying business name:", err);
            },
        });
    }
}
